export const WeatherCategories = {
  current: "CURRENT",
  hourly: "HOURLY",
  daily: "DAILY",
  monthly: "MONTHLY",
};

export const DayPeriods = {
  day: "DAYTIME",
  night: "NIGHTTIME",
  fullday: "FULLDAY",
};

export const TemperatureUnits = {
  c: "C",
  f: "F",
};
